<template>
  <div ref="inletMenuHolder" class="inlet-menu-holder">
    <div class="inlet-label">SOURCE</div>
    <NumericField :type="'origin'" layout="row" color="white" buttonColor="none"/>
    <div class="inlet-menu-spacer ims-long"></div>
    <NumericField :type="'pressure'" layout="row" color="white" buttonColor="none"/>
    <div class="inlet-menu-spacer"></div>
  </div>
</template>

<script>
import NumericField from '@/components/nelson/NumericField';
import { gsap } from 'gsap';
import { nextTick } from 'vue';
import { useSegmentStore } from '@/store/SegmentStore';
import * as UnitConversion from '@/services/UnitConversionService';
import { useSettingsStore } from '@/store/SettingsStore';

export default {
  name: 'InletBar',
  components: {
    NumericField
  },
  data () {
    return {
      isExpanded: true,
      startX: 0,
      x: 0,
      startY: 0,
      y: 0
    };
  },
  watch: {
    getInletPosition (to, from) {
      const inletMenuWidth = document.querySelector('.inlet-menu-holder').clientWidth;
      const inletLoc = document.getElementById('inletArea').getAttribute('x');
      if (to != from) {
        if (JSON.parse(inletLoc) < 150) {
          if (JSON.parse(inletLoc) == 0) {
            gsap.set(this.$el, {
              left: this.getInletPosition + inletMenuWidth,
              top: 35
            });
          } else {
            gsap.set(this.$el, {
              left: JSON.parse(inletLoc) + inletMenuWidth,
              top: 35
            });
          }
        } else {
          if (to > from) {
            if (to != from) {
              gsap.set(this.$el, {
                left: JSON.parse(inletLoc) - inletMenuWidth,
                top: 35
              });
            }
          } else {
            if (inletLoc - inletMenuWidth < 0) {
              gsap.set(this.$el, {
                left: JSON.parse(inletLoc) - inletMenuWidth,
                top: 35
              });
            } else {
              gsap.set(this.$el, {
                left: inletLoc - inletMenuWidth,
                top: 35
              });
            }
          }
        }
      }
    }
  },
  mounted () {
    if (this.$refs.inletArrow != undefined) {
      gsap.set(this.$refs.inletArrow, {
        rotation: 180
      });
    }
    gsap.set(this.$el, {
      left:30,
      top: 35
    });
    this.isExpanded = false;
  },
  computed: {
    getInletPosition () {
      return useSegmentStore().getInletPosition;
    }
  },
  methods: {
    filterLength (length) {
      return (UnitConversion.FilterLength(length, useSettingsStore().getLengthUnit)).toFixed(2);
    },
    handleInletMenuDown (e) {
      this.startX = e.clientX;
      this.x = Number(this.$refs.inletMenuHolder.style.left.replace('px',''));
      this.startY = e.clientY;
      this.y = Number(this.$refs.inletMenuHolder.style.top.replace('px',''));
      document.body.addEventListener('mousemove', this.handleMouseMove);
      document.body.addEventListener('mouseup', this.handleMouseUp);
    },
    handleMouseMove (e) {
      this.handleBoundsX(e);
      this.handleBoundsY(e);
    },
    handleBoundsX (e) {
      let newX = e.clientX - this.startX;
      let newValueX = this.x + newX;
      if (newValueX < 0) { newValueX = 0; }
      let width = this.$el.getBoundingClientRect().width;
      if (newValueX + width > pipeEditor.getBoundingClientRect().width) {
        newValueX = pipeEditor.getBoundingClientRect().width - width;
      }
      this.$refs.inletMenuHolder.style.left = newValueX + 'px';
    },
    handleBoundsY (e) {
      let newY =  e.clientY - this.startY;
      let newValueY = this.y + newY;
      if (newValueY < 0) { newValueY = 0; }
      let pipeEditor = document.getElementById('pipe-editor');
      let height = this.$el.getBoundingClientRect().height;
      if (newValueY + height > pipeEditor.getBoundingClientRect().height) {
        newValueY = pipeEditor.getBoundingClientRect().height - height;
      }
      this.$refs.inletMenuHolder.style.top = newValueY + 'px';
    },
    handleMouseUp () {
      document.body.removeEventListener('mousemove', this.handleMouseMove);
      document.body.removeEventListener('mouseup', this.handleMouseUp);
    },
    handleExpand () {
      this.isExpanded = !this.isExpanded;
      gsap.to(this.$refs.inletArrow, {
        rotation: (!this.$.data.isExpanded) ? -180: 0,
        duration: .3
      });
      nextTick(() => {
        this.startX = this.$el.getBoundingClientRect().left;
        this.startY = this.$el.getBoundingClientRect().top;
        this.handleBoundsX({ clientX: this.startX });
        this.handleBoundsY({ clientY: this.startY });
      });
    }
  }
};
</script>

<style scoped>
.inlet-menu-holder {
/*  user-select: none;*/
/*  position:relative;*/
 /* z-index: 5;
  top:0;
  right: 0;*/
/*  width: 130px;*/
  max-height: 150px;
  background-color: var(--nelson-blue);
  color: white;
 /* border: .5px solid gray;
 */ display: flex;
  align-items: center;
  padding-top: 2px;
  padding-bottom: 2px;
/*  justify-content: center;
  */
/*  cursor: move;*/
}
.inlet-menu-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 1px;
}
.inlet-menu-spacer {
  height: 5px;
}
.inlet-menu-arrow-holder {
  width: 12px;
  margin-right:17px;
  margin-top:-2px;
  cursor: pointer;
}
.inlet-menu-label {
  font-size: 70%;
  font-weight: bold;
  margin-left: 10px;
  margin-top: 3px;
}
.inlet-menu-line {
  width: 90%;
  height: .5px;
  background-color: gray;
  margin-bottom: 3px;
}

.inlet-label {
  font-size: 12px;
  font-weight: bold;
  padding-left: 10px;
}

.ims-long {
  border-right: 1px solid black;
  padding-left: 14px;
  height: 90%;
}
</style>